<template>
  <div id="radio" :style="{background:bgc}">
    <span v-for="(i,index) in selected" :key="index" :class="{'active':index == selected_active}"
      @click="t(index)">{{i}}</span>
  </div>
</template>
<script>
  export default {
    data () {
      return {
        selected: ['日','月','年'],
        selected_active: 0,
        i: 0,

      }
    },
    //利用计算属性  
    computed: {
      bgc () {
        // return this.$store.state.settings.bgc
        return "#fff"
      },
    },
    methods: {
      t (v) {
        if(this.i!=v) {
          this.$emit('childEvent',v);
        }
        this.i=this.selected_active=v;

      }
    }

  };
</script>
<style lang="scss" scoped>
  #radio {
    position: fixed;
    top: 40%;
    z-index: 9;
    display: flex;
    flex-direction: column;
    border: 1px solid #d7d7d7;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    background: rgba(0, 0, 0, 0.05);

    >span {
      padding: 5px;
    }

    .active {
      background: #27a9e3 !important;
      color: #fff;
      cursor: pointer;
    }

    >span:hover {
      background: #27a9e3 !important;
      color: #fff;
      cursor: pointer;
    }
  }
</style>